// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__C6_Qz","content":"page_content__mCwh3"};